import { ViewModel,View } from "binder"
import  { DistrictMonthlySaleBenefitsReportView } from "./districtMonthlySaleBenefitsReport-view"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { downloadFile } from "src/uicomponents/components/utilities";

export class DistrictMonthlySaleBenefitsReportViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'سود ماهانه شعب'
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.reportDate = moment.utc();
    }
    GetDefaultView(): View <ViewModel> {
        return new DistrictMonthlySaleBenefitsReportView();
    }
    public getTypeId(): string {
        return "VM-66E4AEF5-1546-4FE8-9170-DF4CAEC80B57"
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set reportDate(v: moment.Moment) { this._reportDate = v; } public get reportDate(): moment.Moment { return this._reportDate;} private _reportDate: moment.Moment;
    
    async calculate(){
        try {
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/ReportServices/GetDistrictMonthlySaleBenefits',{
                ReportDate : this.reportDate
            });
            if(result.IsSuccessful==false){
                this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا در انجام عملیات');
            }else{
                downloadFile(result.Data,"سود شعب.xlsx")
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }    
    }
}
